<script setup lang="ts">
import type { Component } from 'vue'

const props = withDefaults(defineProps<{ name: string }>(), {})
const modules = import.meta.glob('/src/icons/svg/*.svg', { eager: true })
// console.log('modules', modules)
const currentComponent = computed<Component>(() => {
  const fileName = `/${props.name}.svg`
  for (const path in modules) {
    const mod = modules[path]
    if (path.endsWith(fileName)) {
      // console.log('mod', mod)
      return mod as Component
    }
  }
  throw new Error(`not found svg file:${fileName}`)
})
</script>

<template>
  <component :is="currentComponent" class="svg-icon" />
</template>

<style lang="scss">
  .svg-icon {
    margin-right: 5px;
  }

  .svg-icon__return {
    height: 14px;
  }
</style>
